module.exports = __webpack_public_path__ + "img/JNE.c52d4aa2.png";